export const multiDomainMgmtRoute = 'multi-domain-mgmt';
export const invitationDomainIdQueryParam = 'invitationDomainId';
export const leftDomainNameQueryParam = 'leftDomainName';
export const userExistsQueryParam = 'userExists';
